import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import globalData from 'Src/js/global/window-data';
import ProductListPrice from 'JS/catalog/components/product-list/price/ProductListPrice.vue';
import ProductService, { AddToCartResult, IPDPAddToCartResponse } from 'JS/services/ProductService';
import { computed, ref } from 'vue';
import { defaultFulfillmentMethod } from 'JS/utilities/product/default-fulfillment-method';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { IProductCarouselProduct } from 'Src/js/types/Carousel';
import { IQuickCartSummaryJson } from 'JS/types/Order';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatapultBannerProductCard',
  props: {
    product: null
  },
  emits: ["product-click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'product-click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	product: IProductCarouselProduct;
}





const productAdded = ref(false);
const productLoading = ref(false);
const productAddError = ref(false);
const productService = new ProductService();
const { isMobile } = useBreakpoints();


const atcButtonText = computed(()=> {

	if (isMobile.value) {
		if (productAddError.value) {
			return "Error";
		}

		if (productAdded.value) {
			return '';
		} else {
			return 'Add';
		}

	} else {
		if (productAddError.value) {
			return "Try Again";
		}

		if (productAdded.value) {
			return 'Added';
		} else {
			return 'Add to cart';
		}
	}
});

//Copied from the BuyItAgainCarousel.vue as a way of removing the "todays price" and the was price.
function removePriceText(price) {
	return { ...price, pricePromoText: null, hideWasPrice: true };
}

async function addToCart(): Promise<void> {
	productLoading.value = true;

	emit('product-click');

	const fulfillmentType: FulfillmentType =
		defaultFulfillmentMethod({
			hasExistingCart: (globalData?.cartSummary?.cartQty ?? 0) > 0,
			canShip: props.product.canShip,
			canPickup: props.product.canPickup,
			canDeliver: props.product.canDeliver,
			hasItemsToShip: (globalData?.cartSummary?.hasItemsToShip ?? false),
			hasPickupItems: (globalData?.cartSummary?.hasPickupItems ?? false),
			hasDeliveryItems: (globalData?.cartSummary?.hasDeliveryItems ?? false),
			bopusOnly: false });


	const response: IPDPAddToCartResponse = await productService.addToCart({
		blainNumber: props.product.blainNumber,
		qty: 1,
		userConfirmed: true,
		userAgreed: false, // quick add products should not have a product agreement in the first place
		updateSubscriptionRequest: null,
		skipUpsell: true,
		ignoreFulfillmentType: true,
		fulfillmentType: fulfillmentType,
	});

	addToCartResponse(response);
}

function addToCartResponse(res: IPDPAddToCartResponse): void {
	if (res?.result != AddToCartResult.Success) {
		productAddError.value = true;
	} else  {
		updateHeader(res.cartSummary);
		productAdded.value = true;
		productAddError.value = false;

		const cartProduct = res.cartSummary.productsInCart.find(cartProduct => cartProduct.blainNumber === props.product.blainNumber);
		// Add to Cart event for Google Tag Manager
		const orderProducts = res.cartSummary.productsInCart.map(item => ({
			blainNumber: item.price.blainNumber,
			qty: item.qty,
			unitPrice: item.price.price,
			vendorBrand: item.vendorBrand,
			productName: item.productName,
			imageUrl: item.imageUrlLarger,
			productUrl: item.virtualURL
		}));

		window.blainGtmDataLayer.push({ orderProducts: null }); // orderProducts needs to be reset first to avoid conflicts
		window.blainGtmDataLayer.push({
			'blainNumber': props.product.blainNumber,
			'vendorBrand': props.product.vendorBrand,
			'productName': props.product.productName,
			'deliveryChannel': FulfillmentType.StandardShipping,
			'totalValue': cartProduct.unitPrice,
			'qty': 1,
			'orderProducts': orderProducts,
			'orderId': res.orderID,
			'event': "cart_ajax_add"
		});
	}

	productLoading.value = false;

}

function updateHeader(cartSummary: IQuickCartSummaryJson): void {
	if (window.vueEventBus && cartSummary) {
		window.vueEventBus.$emit('update-quick-cart', cartSummary);
	}
}



return { __sfc: true,props, emit, productAdded, productLoading, productAddError, productService, isMobile, atcButtonText, removePriceText, addToCart, addToCartResponse, updateHeader, BButton, ProductListPrice }
}

})